module.exports = __webpack_public_path__ + "img/deloitte-case-academy.874bbe05.svg";